import React from 'react'

type CaseStudyModalProps = {
  show: boolean
  onClose: () => void
  portfolioData: {
    vWhatWeDid?: string
    vPortfolioChallenges?: string
    vHowWeSolved?: string
    vTechStackUsed?: string
  }
}

const CaseStudyModal: React.FC<CaseStudyModalProps> = ({show, onClose, portfolioData}) => {
  if (!show) return null

  const renderField = (title: string, content: string | undefined) => {
    if (!content || content.trim() === '') return null

    return (
      <div className='mb-4'>
        <h6 className='text-dark fw-bolder mb-3'>{title}</h6>
        <div
          className='text-gray-700 rich-text-content'
          dangerouslySetInnerHTML={{__html: content}}
          style={{
            lineHeight: '1.6',
            fontSize: '14px',
          }}
        />
      </div>
    )
  }

  return (
    <div className='modal fade show d-block' style={{backgroundColor: 'rgba(0,0,0,0.3)'}}>
      <div className='modal-dialog modal-xl modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header py-3'>
            <h5 className='modal-title w-100 text-center'>Case Study</h5>
            <button
              type='button'
              className='btn-close'
              style={{
                outline: 'none',
                boxShadow: 'none',
              }}
              onClick={onClose}
            />
          </div>

          <div className='modal-body py-3'>
            {renderField('What we did for this client?', portfolioData.vWhatWeDid)}
            {renderField('Challenges faced', portfolioData.vPortfolioChallenges)}
            {renderField('How we solved the challenges?', portfolioData.vHowWeSolved)}
            {renderField('Technology stack used', portfolioData.vTechStackUsed)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CaseStudyModal
